
let audio;

export const playNotificationSound = () => {
  try {
    if (!audio) {
      audio = new Audio("/chat/sound.mp3");

      audio.volume = 0.6;
    }

    audio.currentTime = 0; // restart sound
    audio.play().catch(() => {
      // Browser blocked autoplay – ignored safely
    });
  } catch (err) {
    console.log("Sound error:", err);
  }
};
